import axios from "axios";
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

const crmFailList = async () => {
  const { data } = await axios.get(`${baseUrl}/crm/list/fail`);
  return data;
};

const searchCrmHistoryList = async (param) => {
  const { data } = await axios.get(`${baseUrl}/crm/list/search`, {
    params: param,
  });
  return data;
};

const changeCRMListToWait = async (param) => {
  const { data } = await axios.post(`${baseUrl}/crm/list/change/wait`, param);
  return data;
};

const crmApi = {
  crmFailList,
  searchCrmHistoryList,
  changeCRMListToWait,
};

export default crmApi;
